<script lang="ts">
export default {
    name: "Offcanvas",
    inheritAttrs: false,
};  
</script>
<script setup lang="ts">
import { onMounted, onUnmounted, ref, Teleport, nextTick } from 'vue';
import { Offcanvas } from 'bootstrap';
import $ from 'jquery';

interface Props {
    title?: string | false;
    type?: string;
    fullScreen?: boolean;
    label?: string;
    empty?: boolean;
    buttonAttrs?: any;
    backdrop?: boolean;
    keyborad?: boolean;
    scroll?: boolean;

}
const { title, label, type, fullScreen, empty, buttonAttrs, backdrop, keyborad, scroll } = withDefaults(defineProps<Props>(), {
    title: '',
    type: 'end',
    fullScreen: false,
    empty: false,
    label: 'Offcanvas',
    buttonAttrs: {},
    backdrop: true,
    keyborad: true,
    scroll: true,
});

const offElement = ref<any>(null)
const offcanvas = ref<any>(null)
const btnElt = ref<any>(null)
let mainLayout = document.querySelector('.main-wrapper');
let header = document.querySelector('.header-wrapper');
let footer = document.querySelector('.footer-wrapper');


const createOffcanvas = () => {
    offcanvas.value = new Offcanvas(offElement.value, {
        backdrop: backdrop,
        keyborad: keyborad,
        scroll: scroll,
    })
}

const open = () => {
    console.log('X')
    mainLayout?.classList.add('blur');
    header?.classList.add('blur');
    footer?.classList.add('blur');
    offcanvas.value.show()
}

const close = () => {
    console.log('Close')
    mainLayout?.classList.remove('blur');
    header?.classList.remove('blur');
    footer?.classList.remove('blur');
    offcanvas.value.hide()
}
//The function defineExpose give to possibality of use  some component functions from outside 
defineExpose({ open, close })

onMounted(() => {
    $(btnElt.value).off('dblclick')
    createOffcanvas()
})
onUnmounted(() => {
    offcanvas.value?.dispose()
})
</script>
<style scoped lang="scss">
.fullScreen {
    width: 100%;
    height: 100%;
}

.btn {
    border: none;
    outline: none;

    &:focus {
        border: none;
        outline: none;
    }
}

.offcanvas-body {
    padding: 0;
}
</style>
<style scoped lang="scss">
.btn-close {
    padding: 0;
    box-shadow: none;

    &:focus {
        box-shadow: none;
    }
}
</style>
<template>
    <button @click.prevent.stop="open" class="btn" v-bind="buttonAttrs" type="button" ref="btnElt">
        <slot name="button">{{ label }}</slot>
    </button>
    <Teleport to="body">
        <div tabindex="-1" :class="[{ 'fullScreen': fullScreen }, 'offcanvas offcanvas-' + type]" ref="offElement"
            v-bind="$attrs">
            <div v-if="!empty" class="offcanvas-header">
                <h5 v-if="title">{{ title }}</h5>
                <button @click.prevent.stop="close" type="button" class="btn-bit-close"></button>
            </div>
            <div class="offcanvas-header">
                <button @click.prevent.stop="close" type="button" class="btn-bit-close"></button>
                <div class="logo"></div>
            </div>
            <div class="offcanvas-body">
                <slot></slot>
            </div>
        </div>
    </Teleport>
</template>